export const Dimensions = {
	VIEWMODE: 'events_view_mode',
	WAS_PERSONALISED: 'was_personalised',
	EVENT_ID: 'event_id',
	EVENT_NAME: 'event_name',
	SEARCH_TEXT: 'search_text',
	COOKIE_ID: 'cookie_id',
	REC_TIMEOUT: 'rec_timeout',
	REC_FILLED: 'rec_filled',
	PERSONALISED_TYPE: 'personalised_type',
	SEARCH_RESULT: 'search_result'
} as const;

export const Events = {
	EVENTS_VIEW_CHANGED: 'EVENTS_VIEW_CHANGED',
	BUY_CLICK: 'BUY_CLICK',
	VIEW_EVENT: 'VIEW_EVENT',
	SEARCH_TOP_BAR: 'SEARCH_TOP_BAR',
	SEARCH_RESULT: 'SEARCH_RESULT',
	SEARCH_ABANDONED: 'SEARCH_ABANDONED',
	PLAY_SPOTIFY: 'PLAY_SPOTIFY',
	NEWSLETTER_SIGNUP_NYHEDSBREV: 'NEWSLETTER_SIGNUP_NYHEDSBREV',
	NEWSLETTER_SIGNUP_HALF_PRICE: 'NEWSLETTER_SIGNUP_HALF_PRICE',
	NEWSLETTER_SIGNUP_KLUB_HUND: 'NEWSLETTER_SIGNUP_KLUB_HUND',
	LOADED_RECOMMENDATIONS: 'LOADED_RECOMMENDATIONS',
	SAFARI_MULTIPLE_TRANSITIONS: 'SAFARI_MULTIPLE_TRANSITIONS',
	EVENT_CLICKED: 'EVENT_CLICKED'
} as const;

export const Pixel = {
	VIEW: 'ViewContent',
	SEARCH: 'Search',
	ADDTOCART: 'AddtoCart',
	LEAD: 'Lead',
	REGISTRATION: 'CompleteRegistration'
} as const;
